import { MinzeElement } from 'minze'

export interface LvcShowPasswordIcon {}

export class LvcShowPasswordIcon extends MinzeElement {
  html = () => `
    <svg width="20" height="20" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M2 10C2.61361 11.1287 3.82832 12.5853 5.42522 13.948M30 11.4253C28.3004 12.9004 27.6347 13.6022 26.0962 14.632M5.42522 13.948L1.99997 16.5523M5.42522 13.948C6.93237 15.2342 8.77997 16.4368 10.7839 17.2014M26.0962 14.632L29.58 18.7851M26.0962 14.632C24.0916 15.9737 21.5774 17.191 18.5907 17.7384M10.7839 17.2014C11.8885 17.6229 13.0406 17.9113 14.2094 18.0073C14.4315 18.0255 14.6541 18.0368 14.8771 18.0407C15.639 18.0542 16.3772 18.022 17.0913 17.9505C17.6036 17.8992 18.1034 17.8277 18.5907 17.7384M10.7839 17.2014L8.46736 21.1565M18.5907 17.7384L19.9191 21.6667" stroke="#1E007D" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  `

  css = () => `
    
  `
}
